import React from "react";
import PageTitle from "../../../layout/PageTitle";
import {useMutation, useQuery} from "@apollo/client";
import {deleteIngredientMutation, getIngredients} from "./IngredientQueries";
import ListTable from "../../shared/ListTable";
import {AddButton, DeleteButton, EditButton} from "../../../helpers/ButtonHelper";
import {deleteItem} from "../../../helpers/Api";
import {Container} from "react-bootstrap";
import {Link} from "react-router-dom";

const IngredientsList = () => {
  const {data} = useQuery(getIngredients)
  const [deleteCall] = useMutation(deleteIngredientMutation, {refetchQueries: [getIngredients]})

  const header = <tr>
    <th>Denumire</th>
    <th>Descriere</th>
    <th className='actions'></th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>
        <Link to={`/ingredients/${item.id}`}>
          {item.name}
        </Link>
      </td>
      <td>{item.details}</td>
      <td className='actions'>
        <EditButton to={`/ingredients/${item.id}`}/>
        <DeleteButton onClick={e => deleteItem(e, item.id, deleteCall)}/>
      </td>
    </tr>
  }

  return (
    <Container>
      <PageTitle title='Ingrediente' buttons={<AddButton to='/ingredients/new'/>}/>

      <div className="row justify-content-md-center">
        <div className="page-container col">
          <ListTable data={data && data.ingredients} header={header} listItem={listItem}/>
        </div>
      </div>
    </Container>
  )
};

export default IngredientsList;